import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doc-type-grid',
  templateUrl: './doc-type-grid.component.html',
  styleUrls: ['./doc-type-grid.component.css']
})
export class DocTypeGridComponent implements OnInit {

  title="Contractor Doucment Type";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/contractor-doc-type/doc-type-grid/doc-type-grid.component.ts